import React from 'react';
import DatePicker, {registerLocale} from 'react-datepicker';
import {useTranslation} from 'react-i18next';
import nl from 'date-fns/locale/nl';
import en from 'date-fns/locale/en-GB';

registerLocale('nl', nl);
registerLocale('en-US', en);
import 'react-datepicker/dist/react-datepicker.css';
import {FormCalendarMenuList} from '../../form-control-features/FormCalendarMenuList';

export function GenericDatePicker({
    dateFormat,
    dayClassName,
    disabled,
    endDate,
    excludeDateIntervals,
    name,
    onChange,
    onKeyDown,
    openToDate,
    selectsRange,
    selected,
    selectedDates,
    setSelectedDates,
    showTimeSelect,
    showWeekNumbers,
    specialClass,
    startDate,
    weekPicker,
}) {
    const {i18n, t} = useTranslation();

    return (
        <>
            <FormCalendarMenuList />
            <DatePicker
                autoComplete="off"
                calendarContainer={({className, children}) => (
                    <div className={`form-datepicker-container ${specialClass ? specialClass : ''} ${className || ''}`}>
                        {children}
                    </div>
                )}
                className="form-datepicker-input"
                dateFormat={dateFormat}
                dayClassName={dayClassName}
                disabled={disabled}
                endDate={endDate}
                excludeDateIntervals={excludeDateIntervals}
                id={name}
                locale={i18n.language}
                name={name}
                onChange={onChange}
                onKeyDown={onKeyDown}
                openToDate={openToDate}
                portalId="datepicker-portal"
                selected={selected}
                selectedDates={selectedDates}
                selectsRange={selectsRange}
                setSelectedDates={setSelectedDates}
                showTimeSelect={showTimeSelect}
                showWeekNumbers={showWeekNumbers}
                startDate={startDate}
                timeCaption={t('generalShared.time')}
                weekPicker={weekPicker}
            />
        </>
    );
}
